import { useParams } from "react-router-dom";
import { Page } from "@/components/layout/page";
import { ContextView } from "@/components/context/context-view";

export function ProjectUnderstandingPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;

  return (
    <Page
      title="Project context"
      description="Domain understanding, real-world actors, and system scope that ground walkthrough runners."
    >
      <ContextView projectId={id} />
    </Page>
  );
}
